<template>
  <div>
    <v-card>
      <v-toolbar flat color="white">
        <v-toolbar-title>
          <v-icon class="mb-1">mdi-truck</v-icon>
          Recepciones de Carga
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-chip small color="blue" dark label>
          {{ totalItems }} registros
        </v-chip>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="busqueda"
          @click:append="cargarLista()"
          @keyup.enter="cargarLista()"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          class="mt-2"
        >
        </v-text-field>
        <v-menu
          v-model="menuFecha"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
          class="mt-2 ml-4"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="fechaFiltro"
              label="Fecha"
              prepend-icon="mdi-calendar"
              
              v-bind="attrs"
              v-on="on"
              clearable
              @click:clear="limpiarFecha()"
              @keyup.enter="cargarLista()"
              class="mt-2"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="fechaFiltro"
            @change="menuFecha = false"
            no-title
          ></v-date-picker>
        </v-menu>
        <v-select
          v-model="busUsuario"
          :items="usuarios"
          label="Usuario"
          item-text="ENTE_NOMBRE"
          item-value="ENTE_ID"
          @change="cargarLista()"
          class="mt-2 mx-4"
          clearable
        ></v-select>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="lista"
        :items-per-page="itemsPerPage"
        :options.sync="options"
        hide-default-footer
        :loading="loadingTable"
        class="elevation-1"
      >
        <template v-slot:item.RCARGA_FECHA="{ item }">
          {{ formatDate(item.RCARGA_FECHA) }}
        </template>
        <template v-slot:item.RCARGA_HORA="{ item }">
          {{ item.RCARGA_HORA ? item.RCARGA_HORA.substring(0, 8) : '' }}
        </template>
        <template v-slot:item.RCARGA_ESTADO="{ item }">
          {{ getEstadoLabel(item.RCARGA_ESTADO) }}
        </template>
        <template v-slot:item.RCARGA_TIPO="{ item }">
          {{ getTipoLabel(item.RCARGA_TIPO) }}
        </template>
        <template v-slot:footer>
          <v-pagination
            class="mt-10"
            v-model="currentPage"
            :length="pageCount"
            @input="handlePageChange"
            total-visible="10"
          ></v-pagination>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  name: "ListaRecepciones",

  components: {},

  data: () => ({
    headers: [
      { text: "ID", value: "RCARGA_ID" },
      { text: "Numero", value: "RCARGA_NUM" },
      { text: "Fecha", value: "RCARGA_FECHA" },
      { text: "Hora", value: "RCARGA_HORA" },
      { text: "Conductor", value: "COND_ID" },
      { text: "Estado", value: "RCARGA_ESTADO" },
      { text: "Tipo", value: "RCARGA_TIPO" },
      { text: "Placa", value: "RCARGA_PLACA" },
      { text: "Usuario", value: "USUARIO_ID" },
      { text: "Usuario Ingreso", value: "USUARIO_INGRESA" },
      { text: "U.Ingreso ID", value: "UINGRESO_ID" },
    ],

    lista: [],
    options: {},
    busqueda: null,
    busUsuario: null,
    fechaFiltro: null,
    menuFecha: false,

    itemsPerPage: 20,
    pageCount: 1,
    totalItems: 0,
    currentPage: 1,

    usuarios: [],
  }),

  computed: {
    ...mapState("master", ["loadingTable", "user"]),
  },

  methods: {
    ...mapMutations("master", [
      "setUrl",
      "setOverlay",
      "setLoadingTable",
    ]),
    ...mapActions("master", ["requestApi"]),

    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      return d.toLocaleDateString("es-ES");
    },

    getEstadoLabel(estado) {
      const estados = {
        0: "Pendiente",
        1: "Procesando",
        2: "Completado",
        3: "Cancelado",
      };
      return estados[estado] || estado;
    },

    getTipoLabel(tipo) {
      const tipos = {
        0: "Normal",
        1: "Especial",
      };
      return tipos[tipo] || tipo;
    },

    limpiarFecha() {
      this.fechaFiltro = null;
      this.cargarLista();
    },

    handlePageChange() {
      this.cargarLista();
    },

    cargarLista() {
      this.setLoadingTable(true);
      this.setUrl("api/lista-recepciones");
      this.requestApi({
        method: "GET",
        data: {
          page: this.currentPage,
          itemsPerPage: this.itemsPerPage,
          r_carga_num: this.busqueda,
          usuario_ingresa: this.busUsuario,
          fecha: this.fechaFiltro,
        },
      })
        .then((res) => {
          this.lista = res.data.lista;
          this.pageCount = res.data.pageCount;
          this.totalItems = res.data.totalItems;
        })
        .catch(() => {})
        .then(() => {
          this.setLoadingTable(false);
        });
    },

    cargarUsuarios() {
      this.setUrl("api/form-recepciones");
      this.requestApi({
        method: "GET",
        data: {
          busqueda: "",
        },
      })
        .then((res) => {
          this.usuarios = res.data.usuarios;
        })
        .catch(() => {});
    },
  },

  mounted() {
    this.cargarUsuarios();
    this.cargarLista();
  },
};
</script>